import { render, staticRenderFns } from "./ArrowSmall.vue?vue&type=template&id=79d45dec&"
import script from "./ArrowSmall.vue?vue&type=script&lang=js&"
export * from "./ArrowSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports